import React from 'react';
import { Button, Flex, Text, Tooltip } from '@applyboard/crystal-ui';
import { InfoOutlineIcon } from '@applyboard/ui-icons';
import { SectionTitle } from "./SectionTitle";
import { consts } from "../utils";
import { useEventTracker } from '@applyboard/ui-utils';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var AutoAppliedSection = function AutoAppliedSection(_ref) {
  var autoApplied = _ref.autoApplied,
    eventTrackingOptions = _ref.eventTrackingOptions;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  return _jsxs(Flex, {
    direction: "column",
    children: [_jsx("div", {
      style: {
        marginTop: '-8px',
        marginBottom: '-4px'
      },
      children: _jsxs(Flex, {
        direction: "row",
        gap: 1,
        align: "center",
        children: [_jsx(SectionTitle, {
          title: "Auto applied"
        }), _jsx(Tooltip, {
          label: consts.autoAppliedTooltip,
          onOpenChange: function onOpenChange(open) {
            if (open) {
              var _eventTrackingOptions;
              trackEvent({
                event: "".concat((_eventTrackingOptions = eventTrackingOptions === null || eventTrackingOptions === void 0 ? void 0 : eventTrackingOptions.eventsPrefix) !== null && _eventTrackingOptions !== void 0 ? _eventTrackingOptions : '', "Scholarship Card - Hovered Over Auto Applied Tooltip"),
                data: eventTrackingOptions === null || eventTrackingOptions === void 0 ? void 0 : eventTrackingOptions.eventTrackingData
              });
            }
          },
          children: _jsx(Button, {
            size: "sm",
            "aria-label": "Info",
            variant: "transparent",
            leadIcon: InfoOutlineIcon
          })
        })]
      })
    }), _jsx(Flex, {
      direction: "row",
      gap: 1,
      align: "center",
      children: _jsx(Text, {
        children: autoApplied ? 'Yes' : 'No'
      })
    })]
  });
};